import { render, staticRenderFns } from "./PortalNumberField.vue?vue&type=template&id=d7f7deba"
import script from "./PortalNumberField.vue?vue&type=script&lang=ts"
export * from "./PortalNumberField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports